module.exports = __webpack_public_path__ + "static/media/app_store.5c853d67.svg";